import { CheckedChangedEventHandler } from '@sunwebgroup/ui-components'
import { Accordion } from '@sunwebgroup/ui-components/uds'
import { isEmpty } from 'ramda'
import { useIntl } from '@/intl'
import { useAnalytics } from '@/scopes/common/infrastructure/analytics/hooks'
import { createSearchFilterClickEvent } from '@/scopes/search/search/domain/analytics'
import { useSearchDependencies } from '@/scopes/search/search/pages/SearchPage/context'
import { useSelectFilter } from '../../../../domain/hooks'
import { FilterGroupProps } from '../types'
import ListFilterItem from './ListFilterItem'

export function LastMinuteFilter({ defaultOpen }: FilterGroupProps) {
  const intl = useIntl()
  const { sendEvent } = useAnalytics()
  const { options, selectedValue, isFetching } = useSelectFilter('Lastminute')
  const { dateFilterActions: selectDepartureDateActions } = useSearchDependencies()

  const handleFilterChange: CheckedChangedEventHandler = ({ checked, value }) => {
    if (checked) {
      selectDepartureDateActions.setLastMinuteFilterSelection(value?.toString())
      sendEvent(
        createSearchFilterClickEvent({
          element: 'checkbox',
          type: 'departure weeks',
          result: value,
        }),
      )
    }
    else {
      selectDepartureDateActions.setLastMinuteFilterSelection(undefined)
    }
  }

  if (isEmpty(options))
    return null

  return (
    <Accordion.Item title={intl.formatMessage({ id: 'search_filter_last_minute_label' })} defaultOpen={selectedValue !== null || defaultOpen} data-qa="last-minute-filter">
      {options.map(({ name, value, resultsCount }) => (
        <ListFilterItem.Checkbox
          key={name}
          label={name}
          counter={resultsCount}
          checked={selectedValue === value}
          value={value}
          onChange={handleFilterChange}
          disabled={isFetching}
          data-qa="last-minute-filter-option"
          data-qa-value={value?.toLowerCase()}
        />
      ))}
    </Accordion.Item>
  )
}
